/*@ngInject*/
const LoadRowInstanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadRowInstanceList = function (rowId) {
        let url = '/rest/FormRow/' + rowId;

        return this.get(url);
    };
};

angular.module('umFormViewer')
    .service('loadRowInstanceRepository', LoadRowInstanceRepository);
